<template>
      <div class="tab-pane"  id="programmes" aria-labelledby="programmes-tab">
        <div class="card-body">
            <div v-if="!show_application" class="alert alert-warning alert-dismissible fade show" role="alert">
                <span v-if="hasMessage == 2">
                    <strong>APPLICATIONS NOW CLOSED!</strong>
                    <br> THANKS TO EVERYONE WHO APPLIED. STAY TUNED TO HEAR THE RESULT.
                </span>
                <span v-if="hasMessage == 1">
                    <br>APPLICATION WILL OPEN FROM <strong>{{start_date}}</strong> TO <strong>{{end_date}}</strong>. PLEASE REFRESH THE PAGE DURING OPENNING TIME.
                </span>
            </div>
            <form v-else>
                <!-- student Information -->
                <h5>
                    <strong>Student Information</strong>
                </h5>
                <hr class="mt-0">
                <div class=" row form-group">
                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <label for="name" class="form-label">Name: </label>
                        <input type="text" v-model="form.name" class="form-control" id="name" disabled>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <label for="index_number" class="form-label">BCSE-X 2021 Index Number:</label>
                        <input type="text" v-model="form.index_number" class="form-control" id="index_number" disabled>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <label for="student_code" class="form-label">Student Code</label>
                        <input type="text" v-model="form.student_code" class="form-control" id="student_code" disabled>
                    </div>
                </div>
                <div class="row form-group mb-2">
                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <label  class="required">Gender:</label>
                        <br>
                        <label v-if="form.gender =='female'">
                            <input type="radio" v-model="form.gender" value="female" checked disabled>
                             Female
                        </label>
                        <label v-if="form.gender =='male'">
                            <input type="radio" v-model="form.gender" value="male" checked disabled>
                            Male
                        </label>
                        <label v-else>
                            <input  type="radio" v-model="form.gender" value="other" checked disabled>
                            Other
                        </label>
                    </div>
                </div>

                <!-- prevoius school details  -->
                <h5 class="mt-4">
                    <strong>Previous School Information</strong>
                </h5>
                <hr class="mt-0">
                <div class="row form-group mb-3">
                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <label for="name" class="form-label">Dzongkhag: </label>
                        <input v-model="dzongkhag" class="form-control" aria-label="dzongkhags" disabled/>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <label for="name" class="form-label">School: </label>
                        <input v-model="school" class="form-control" aria-label="school" disabled/>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <label  class="required">Where You have Attended Class X:</label>
                        <br>
                        <label v-if="form.isGov =='1'">
                            <input type="radio" v-model="form.isGov" value="1" checked disabled>
                             Government 
                        </label>
                        <label v-else>
                            <input type="radio" v-model="form.isGov" value="0" checked disabled>
                            Private
                        </label>
                    </div>
                </div>
                <!-- academic section -->
                <h5 class="mt-4">
                    <strong>Academic Information</strong>
                </h5>
                <hr class="mt-0">
                <div class="row form-group">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <label for="name" class="form-label">Student Marks:</label>
                       <table class="table table-bordered table-striped" id="subject">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>English</th>
                                    <th>Dzongkha</th>
                                    <th>History</th>
                                    <th>Civics</th>
                                    <th>Mathematics</th>
                                    <th>Chemistry</th>
                                    <th>Biology</th>
                                    <th>Elective</th>
                                    <th>Percentage 
                                        (English+Best Four)
                                    </th>
                                    
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item,index ) in marksheet" :key="index">
                                    <td><strong>Score</strong></td>
                                    <td class="text-right">{{item.english}}</td>
                                    <td class="text-right">{{item.dzongkha}}</td>
                                    <td class="text-right">{{item.history}}</td>
                                    <td class="text-right">{{item.civics}}</td>
                                    <td class="text-right">{{item.mathematics}}</td>
                                    <td class="text-right">{{item.chemistry}}</td>
                                    <td class="text-right">{{item.biology}}</td>
                                    <td class="text-right">{{item.elective}}</td>
                                    <td class="text-right">{{item.percentage}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                  <!-- school options -->
                <h5 class="mt-4">
                    <strong>School Option for Admission in Class XI</strong>
                </h5>
                <hr class="mt-0">
                <div class="row  form-group">
                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <label for="name" class="form-label">Dzongkhag: <span class="text-danger">*</span></label>
                        <select v-model="form.class_xi_dzongkhag_id" class="form-control" aria-label="class_xi_dzongkhag_id" :class="{ 'is-invalid': form.errors.has('class_xi_dzongkhag_id') }" id="class_xi_dzongkhag_id" @change="remove_err('class_xi_dzongkhag_id'); getPrivateOrganization();" >
                             <option selected value="">---SELECT---</option>
                            <option v-for="(item, i) in dzongkhags" :key="i" :value="item.id">{{item.name}}</option>
                        </select>
                        <has-error :form="form" field="class_xi_dzongkhag_id"></has-error>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <label for="name" class="form-label">School: <span class="text-danger">*</span></label>
                        <select v-model="form.class_xi_school_id" class="form-control" aria-label="class_xi_school_id" :class="{ 'is-invalid': form.errors.has('class_xi_school_id') }" id="class_xi_school_id" @change="getStream(),remove_err('class_xi_school_id')">
                            <option selected value="">---SELECT---</option>
                            <option v-for="(item, i) in private_organization" :key="i" :value="item.id">{{item.organization}}</option>
                        </select>
                        <has-error :form="form" field="class_xi_school_id"></has-error>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <label for="class" class="form-label">Class: <span class="text-danger">*</span></label>
                        <input v-model="form.class" class="form-control" aria-label="class" :class="{ 'is-invalid': form.errors.has('class') }" id="stream_id" disabled>
                    </div>
                </div>
                <div class="row  form-group">
                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <label for="stream" class="form-label">Stream: <span class="text-danger">*</span> </label>
                        <select v-model="form.stream" class="form-control" aria-label="stream" :class="{ 'is-invalid': form.errors.has('stream') }" id="stream" @change="remove_err('stream')">
                            <option selected value="">---SELECT---</option>
                            <option v-for="(item, i) in streams" :key="i" :value="item.id">{{item.stream}}</option>
                        </select>
                        <has-error :form="form" field="stream"></has-error>
                    </div>
                  </div>
                <div class="col-md-12 text-right">
                    <button type="button" class="btn btn-primary" @click="submitApplication()"><i class="fas fa-paper-plane"></i>  Submit</button> 
                </div>
            </form>
        </div>
    </div>
</template>
<script>
export default {
    props:['show_application','hasMessage','start_date','end_date'],
    data(){
        return {
            showAlert:false,
            user_type:'',
            form: new form ({
                user_id:'',
                name:'',
                gender:'',
                student_code:'',
                index_number:'',
                contact_number:'',
                dzongkhag_id: '',
                school_id:'',
                isGov:'',
                class_xi_dzongkhag_id:'',
                class_xi_school_id:'',
                class:'XI',
                stream:'',
            }),
            school:'',
            dzongkhag:'',
            marksheet: [],
            dzongkhags:[],
            organization:[],
            private_organization:[],
            streams: [],
        }
    },
    methods:{
        getDzongkhags(){
            axios.get('dzongkhags/getDzongkhags')
            .then(response =>{ this.dzongkhags = response.data })
            .catch(error => console.log(error));
        },
        getUserDetails(user_id){
            axios.get('user/getUser/'+user_id)
            .then(response =>{ 
                let detail = response.data.student_details[0]
                this.form.user_id=detail['id'];
                this.user_type=detail['role'];
                this.form.name = detail['name'];
                this.form.gender = detail['gender'];
                this.form.index_number = detail['std_indexno'];
                this.form.student_code = detail['student_code'];
                this.form.dzongkhag_id = detail['dzongkhag_id'];
                this.dzongkhag = detail['dzongkhag'];
                this.school = detail['organization'];
                this.form.isGov = detail['is_government'];
                this.marksheet = response.data.student_marks
            })
            .catch(error => console.log(error));
        },
        getPrivateOrganization(){
            axios.get('school/getPrivateOrganization/'+this.form.class_xi_dzongkhag_id)
            .then(response =>{ this.private_organization = response.data })
            .catch(error => console.log(error));
        },
        getStream(){
             axios.get('school/getStream/'+this.form.class_xi_school_id)
            .then(response =>{ this.streams = response.data })
            .catch(error => console.log(error));
        },
        remove_err(fieldid){
            if($('#'+fieldid).val()!=""){
                $('#'+fieldid).removeClass('is-invalid');
            }
        },
        submitApplication() {
            this.form.post('admissions/saveOnlineApplication', this.form)
            .then((res) => {
                if(res.data.user_id != undefined && res.data.id != undefined ){
                   Toast.fire({
                        icon: 'success',
                        title: 'Successfully submitted your application'
                    })
                    this.$router.push('/dashboard')
                }else if(res.data.user_id != undefined){
                      Swal.fire({
                        icon: 'warning',
                        text: res.data.user_id[0],
                    })
                }
           
            }).catch((error) => {
                this.form.errors.errors = error.response.data.errors
            });
        }
           

           
    },
    mounted(){
        this.getDzongkhags();
        axios.get('getSessionDetail').then(response => {
            let data = response.data.data;
            this.form.school_id = data['org_organization_id'];
            this.getUserDetails(data['id']);

        })
    }
}
</script>